import classNames from 'classnames';

const CardHeaderButtons = props => {
  const { children, extraClassNames } = props;

  return (
    <div className={classNames('c-card__header-buttons', extraClassNames)}>
      {children}
    </div>
  );
};

export default CardHeaderButtons;
